import { Injectable, signal } from '@angular/core';

const state = {
  isLoaderVisible: signal<boolean>(false),
};

@Injectable({
  providedIn: 'root',
})
export class SynSplashScreenService {
  public readonly $isLoaderVisible = state.isLoaderVisible.asReadonly();

  show(): void {
    state.isLoaderVisible.set(true);
  }

  hide(): void {
    state.isLoaderVisible.set(false);
  }
}
